import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const { FiArrowLeft, FiShield } = FiIcons;

export default function MentionsLegales() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-indigo-600 transition-colors mb-8">
        <SafeIcon icon={FiArrowLeft} />
        Retour au calculateur
      </Link>

      <div className="flex items-center gap-3 mb-8">
        <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
          <SafeIcon icon={FiShield} className="text-indigo-600 text-lg" />
        </div>
        <h1 className="text-3xl font-extrabold text-slate-900">Mentions Légales</h1>
      </div>

      <div className="prose prose-slate max-w-none space-y-8">
        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">1. Éditeur du site</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Le site <strong>salaire-smic.com</strong> est édité à titre personnel par un particulier. Pour toute question, vous pouvez nous contacter via la page <Link to="/contact" className="text-indigo-600 hover:underline">Contact</Link>.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">2. Hébergement</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Ce site est hébergé par un prestataire tiers. Les coordonnées de l'hébergeur sont disponibles sur demande via la page <Link to="/contact" className="text-indigo-600 hover:underline">Contact</Link>.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">3. Propriété intellectuelle</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            L'ensemble des contenus présents sur <strong>salaire-smic.com</strong> (textes, calculs, mise en page, code source) est la propriété exclusive de l'éditeur. Toute reproduction, même partielle, est interdite sans autorisation préalable écrite.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">4. Responsabilité</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Les résultats fournis par ce calculateur sont donnés à titre purement indicatif. Ils ne constituent pas un avis juridique ou fiscal. L'éditeur de <strong>salaire-smic.com</strong> ne saurait être tenu responsable d'une décision prise sur la base de ces estimations. Pour toute situation spécifique, nous vous recommandons de consulter un expert-comptable ou un conseiller RH.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">5. Données personnelles</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Ce site utilise des cookies à des fins publicitaires et statistiques. Pour en savoir plus, consultez notre <Link to="/confidentialite" className="text-indigo-600 hover:underline">Politique de Confidentialité</Link>.
          </p>
        </section>

        <section className="bg-white rounded-2xl p-6 ring-1 ring-slate-900/5 shadow-sm">
          <h2 className="text-lg font-bold text-slate-800 mb-3">6. Droit applicable</h2>
          <p className="text-slate-600 text-sm leading-relaxed">
            Le présent site est soumis au droit français. En cas de litige, les tribunaux français seront seuls compétents.
          </p>
        </section>
      </div>
    </div>
  );
}